module.exports = __webpack_public_path__ + "location.b3c619b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/profile/location.png
// module id = 2246
// module chunks = 0